@import '../../global/style/all-tenants/custom-properties/components-properties/static-teaser';

:host {
  width: 100%;
  display: block;
  margin-bottom: var(--cms-components-mb);
  @include cms-base-font-100;
  /* Override aspect-ratio for article-image */
  --cms-theme-article-image-ratio: 1.6/1;
}

cms-headline {
  --cms-spacing-bottom: var(--cms-spacing-100);
}

.teaser-href:hover {
  cms-link {
    --cms-link-decoration: underline;
  }
}


.target-icon {
  display: flex;
}

.article-info-wrapper {
  height: 100%;
  --cms-theme-text-color: var(--cms-semanticColors-base-strong-text);
}

.teaser-content-inner.article:hover {
  cursor: pointer;
}

.teaser-content-inner.article:hover .target-name {
  --cms-link-decoration: underline;
}

.container-wrapper-inner {
  @include container-wrapper-inner;
}

.teaser-content {
  @include cms-default-grid-container;
  list-style: none;

  .teaser-content-inner.article {
    padding-bottom: var(--cms-spacing-025);
  }
}

.teaser-content-inner {
  @include teaser-content-inner;
}

.article-name {
  color: var(--cms-semanticColors-base-strong-text);
}

.article-image-wrapper,
.category-image-wrapper {
  margin: auto;
}

.teaser-content-inner.category .teaser-href {
  height: 100%;
  display: flex !important;
  flex-direction: column;
}

.category-image,
.article-image {
  aspect-ratio: 1.6/1;
  object-fit: contain;
}

.teaser-cta-container {
  display: flex;
  align-items: center;
  gap: var(--cms-spacing-050);
  @include label-font-125;
}

.teaser-bottom {
  @include cms-static-teaser-bottom;
}

.scratch svg path {
  @include cms-static-teaser-scratch-svg-path;
}

.teaser-bottom svg path {
  @include cms-static-teaser-bottom-svg-path;
}

.badge-wrapper {
  @include cms-static-teaser-badge;
}

.teaser-content-inner:nth-child(2),
.teaser-content-inner:nth-child(3) {
  background-color: var(--cms-semanticColors-container-weak-background);
  color: var(--cms-semanticColors-base-strong-text);
  height: auto;
  padding: var(--cms-spacing-100);

}

.teaser-content-inner:nth-child(3) {
  flex-direction: column;
  justify-content: space-between;
}

@include media-width($breakpoint-sm) {
  cms-headline {
    --cms-spacing-bottom: var(--cms-spacing-150);
  }
}